import { type FormikProps, useFormikContext } from 'formik';

export interface SubmitButtonProps<T = unknown> {
  render: (props: FormikProps<T>) => JSX.Element;
}

export const SubmitButton = <T,>({ render }: SubmitButtonProps<T>) => {
  const formikProps = useFormikContext<T>();
  return render(formikProps);
};
